import createStore from "astrid-helpers/src/createStore";

export const [getSidebar, setSidebar, useSidebar, onSidebar] = createStore(0);
